/**
 * This is the changepassword module configuration.
 * Do NOT configure routes in this file.
 * @memberOf changepassword Module
 * @namespace changepassword Config
 */

/**
 * @name config
 * @desc Configures the module.
 * @memberOf changepassword Module.changepassword Config
 * @ngInject
 */
var config = function () {
}

export default config;


// WEBPACK FOOTER //
// ./src/login/changepassword/changepassword.config.js